import {
  Box,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  VStack,
  Link as ChakraLink,
  Center,
  Flex,
} from '@chakra-ui/react';
import { AxiosError, isAxiosError } from 'axios';
import { Link as RouterLink, useParams } from 'react-router';

import { useUser } from '@/lib/auth';

type ErrorFallbackProps = {
  error: Error;
};
export const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  console.log('1_error.tsx_1');

  const user = useUser();
  const tenantSlug = useParams().tenantSlug;
  // 認証切れの場合は、エラーメッセージを表示せずにリダイレクトを待つ
  if (isAxiosError(error) && error.response?.status === 401) {
    return null;
  }

  return (
    <Center>
      <Box w="800px" mt={8} p={4}>
        <Alert
          status="error"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="auto"
          py={4}
        >
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            エラーが発生しました
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            <Text>
              {/* errorの型がAxiosErrorかどうかを判断 */}
              {/* AxiosErrorではない場合は「何らかのエラーが発生しました」 */}
              {/* error.responseが存在する場合は、error.response.data.messageを表示 */}
              {/* それ以外の場合は、'サーバー内部でエラーが発生しました。'を表示 */}
              {error instanceof AxiosError
                ? error.response?.data.message ||
                  'サーバー内部でエラーが発生しました。'
                : '何らかのエラーが発生しました。'}
            </Text>
          </AlertDescription>
        </Alert>

        <VStack spacing={4} mt={4} align="stretch">
          <Flex justify="center">
            <ChakraLink
              as={RouterLink}
              to={
                user.data
                  ? `/${tenantSlug}/app/document`
                  : `/${tenantSlug}/auth/login`
              }
              color="blue.500"
              fontWeight="medium"
            >
              トップ画面へ戻る
            </ChakraLink>
          </Flex>
        </VStack>
      </Box>
    </Center>
  );
};
